import { render } from "./InstancesListIFrame.vue?vue&type=template&id=7bff423c&ts=true"
import script from "./InstancesListIFrame.ts?vue&type=script&lang=ts&external"
export * from "./InstancesListIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__